import { useMemo } from "react";
import { LazyLoadRowProps } from "../../shared-components/LazyLoadTable";
import { ReportRow } from "../Table";
import type { ReportSummaryItemApi } from "../../api/Reports";
import { useLatestWorkflowStepRunQuery } from "../../api/ReportsApi";
import { reportFailed } from "../utils";
import {
  buildInProcessV2026TableRow,
  mergeLatestStepIntoReport,
} from "./inProcessMisconductV2026Rows";
import { useInProcessMisconductV2026RowContext } from "./InProcessMisconductV2026RowContext";

const InProcessMisconductLazyRow = ({
  parentRow,
  index,
}: LazyLoadRowProps<ReportSummaryItemApi>): JSX.Element => {
  const rowCtx = useInProcessMisconductV2026RowContext();
  const isErrorRow = reportFailed(parentRow);

  const { data: latestStep, isLoading: stepQueryLoading } =
    useLatestWorkflowStepRunQuery(
      parentRow.workflow_run_uuid,
      !isErrorRow && Boolean(parentRow.workflow_run_uuid)
    );

  const stepLoading =
    !isErrorRow && stepQueryLoading && latestStep === undefined;

  const report = useMemo(
    () =>
      isErrorRow ? parentRow : mergeLatestStepIntoReport(parentRow, latestStep),
    [parentRow, isErrorRow, latestStep]
  );

  const tableRow = useMemo(
    () => buildInProcessV2026TableRow(report, { ...rowCtx, stepLoading }),
    [report, rowCtx, stepLoading]
  );

  return <ReportRow reportRow={tableRow} index={index} />;
};

export default InProcessMisconductLazyRow;
